import script from "./Logo.vue?vue&type=script&setup=true&lang=js"
export * from "./Logo.vue?vue&type=script&setup=true&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=5ecc3917&scoped=true&lang=less"
script.__scopeId = "data-v-5ecc3917"

export default script